import _emojiRegex from 'emoji-regex'

export const koreanOnlyRegex = /^[ㄱ-ㅎ가-힣ㅏ-ㅣ]+$/
export const englishOnlyRegex = /^[a-zA-Z]+$/
export const numberOnlyRegex = /^[0-9]+$/
export const emojiRegex = _emojiRegex()
export const spaceRegex = /\s+/g
export const newlineRegex = /\n+/g
